import { Link } from 'react-router-dom';
import type { VideoItem } from '@/types/content';
import { formatViews } from '@/utils/content';

interface VideoCardProps {
  item: VideoItem;
}

export default function VideoCard({ item }: VideoCardProps) {
  return (
    <Link to={`/video/${item.id}`} className="group block cursor-pointer">
      <div className="relative w-full h-44 md:h-48 rounded-lg overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${item.typeName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/85 via-background-50/10 to-transparent" />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
          {item.typeName}
        </span>
        <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-background-50/85 text-foreground-950 text-xs font-medium">
          {item.duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>
      </div>
      <h3 className="font-heading text-base font-semibold text-foreground-950 mt-3 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
        {item.title}
      </h3>
      <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line" />
          {formatViews(item.views)} 次播放
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-price-tag-3-line" />
          {item.categoryName}
        </span>
      </div>
    </Link>
  );
}